import { DeleteAccountByPkService } from './../../services/delete-account-by-pk.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';

@Component({
  selector: 'app-delete-supplier-account',
  templateUrl: './delete-supplier-account.component.html',
  styleUrls: ['./delete-supplier-account.component.scss']
})
export class DeleteSupplierAccountComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<DeleteSupplierAccountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private deleteAccountByPkService: DeleteAccountByPkService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  delete(){
    this.deleteAccountByPkService.deleteSupplierAccountByPk(this.data.id).
    subscribe(success=>{
      this.toast.openSnackBar("Account is deleted successfully");
      this.closeDialog('yes');
    },failure => {
      this.toast.openSnackBar("Unable to delete account");
    })
  }
}
